import { Migration } from '@mydocma/core/src/lib/migration';
import { IDBPDatabase } from 'idb';
import { MmProjectDbCollections } from '../../mm-project-db-schema';

export const V10: Migration = {

  up(database: IDBPDatabase<unknown>) {
    database.deleteObjectStore(MmProjectDbCollections.fault_patches);
    const store = database.createObjectStore(MmProjectDbCollections.fault_patches,  { keyPath: 'operation.id' });
    store.createIndex('fUid', 'fUid', { unique: false});
    store.createIndex('gUid', 'gUid', { unique: false});

    // let tx = database.transaction(MmProjectDbCollections.faults);
    // database.deleteObjectStore(MmProjectDbCollections.faults);
    // let store = database.createObjectStore(MmProjectDbCollections.faults,  { keyPath: 'uid' });
    // store.createIndex('gUid', 'gUid', { unique: false});
  },

};
